const DEV_API_BASE_URL_LOC = 'http://localhost:8080';
const DEV_API_BASE_URL = 'https://codefab.dev/loc/API';
export const DEBOUNCE_DURATION = 250;
export const BASE_FE_PATH = ""; // "" or "/loc"!
export const SPACING = 2;
export const emptyCharacter = "\u00A0";

export const getBaseURL = () => {
    if (window.location.href.includes('localhost')) {
        return DEV_API_BASE_URL_LOC;
    }
    if (window.location.origin === 'https://codefab.dev') {
        return DEV_API_BASE_URL; // legacy shared dev path
    }
    // Prod: API is served on the same host as the SPA, under /API. Host-agnostic
    // so it works for omsv2.codefab.dev now and oms.codefab.dev after cutover.
    return `${window.location.origin}/API`;
}

export const isProd = () => {
    return !window.location.href.includes('localhost')
        && window.location.origin !== 'https://codefab.dev';
}

// Keycloak (OIDC) — dev defaults; prod supplies these via REACT_APP_* at build time.
export const KEYCLOAK_AUTHORITY =
    process.env.REACT_APP_KEYCLOAK_AUTHORITY || 'http://localhost:8082/realms/oms';
export const KEYCLOAK_CLIENT_ID =
    process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'oms-web';

export enum RoutePath {
    Default = '/',
    Home = '/home',
    Signin = '/signin',
    Dashboard = '/dashboard',
    Demo = '/demo',
    Overview = '/overview',
    ExternalRegister = '/external-register',
    Worksites = '/worksites',
    Customers = '/customers',
    Orders = '/orders',
    PerformedJob = '/performed-job',
    PREFIX = '/products/OMS',
    Tasks = '/tasks',
    TemplateEditor = '/template-editor',
    JobSummary = '/job-summary',
    ResetPassword = '/reset-password',
    Products = '/products',
    Resources = '/resources',
    Properties = '/properties',
    SystemSettings = '/system-settings',
    CustomerImport = '/import/customers',
    WorksiteImport = '/import/worksites',
    SelectInstance = '/select-instance',
    Users = '/users',
    // Add more routes as needed
}